import React from "react";
import {connect} from "react-redux";
import Administration from "../components/Administration";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

const AdministrationContainer = () => {
    return (
        <div>
            <Administration/>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationContainer);


// WEBPACK FOOTER //
// ./src/container/AdministrationContainer.js